export default "__VITE_ASSET__CRIR48pZ__"